<template>
    <div>
        <el-dropdown  class="locale-box" popper-class="common-popper" @command="handleDropdown">
            <icon-svg-translate class="w-30 h-30 text-[var(--text-color)] rounded-6 border-none bg-[rgba(255,255,255,0.1)] cursor-pointer outline-none" />
            <template #dropdown>
                <el-dropdown-menu>
                    <el-dropdown-item :class="{ 'active': curIdx === 0 }" :command="0" @click="changeLanguage">中文（简体）</el-dropdown-item>
                    <el-dropdown-item :class="{ 'active': curIdx === 1 }"  :command="1" @click="changeLanguage">English</el-dropdown-item>
                </el-dropdown-menu>
            </template>
        </el-dropdown>
    </div>
    <!-- <div
        class="flex font-400 font-demibold relative h-30 w-60 line-height-30 text-center rounded-30 bg-#fff bg-op-20 text-12 color-#fff cursor-pointer"
    >
        <span
            class="block h-full duration-300 transition-all w-30 rounded-15 absolute left-0 bg-#60e4ff z-0"
            :class="[currentLocale === 'zh-CN' ? 'left-0' : 'left-30']"
        ></span>
        <span
            :key="getLocaleOption[0].value"
            class="cursor-pointer transition-all duration-300 w-30 z-1"
            :class="{ 'text-#000': currentLocale === 'zh-CN' }"
            @click="changeLanguage"
        >
            中
        </span>
        <span
            :key="getLocaleOption[1].value"
            :class="{ 'text-#000': currentLocale === 'en' }"
            class="cursor-pointer transition-all duration-300 w-30 z-1"
            @click="changeLanguage"
        >
            英
        </span>
    </div> -->
</template>
<script setup lang="tsx">
import { useLocale } from '@/hooks/useLocale';
import { LocaleTypeEnum } from '@/store/locale';

const { getCurrentLocale, getLocaleOption, currentLocale } = useStore('locale');
const { changeLocale } = useLocale();
let curIdx = ref(0);
const changeLanguage = () => {
    const { setCurrentLocale } = useStore('locale');
    const locale = getCurrentLocale.value === LocaleTypeEnum.English ? LocaleTypeEnum.Chinese : LocaleTypeEnum.English;
    setCurrentLocale(locale);
    changeLocale(locale);
    curIdx.value = locale === LocaleTypeEnum.Chinese ? 0 : 1
};

watch(getCurrentLocale, (locale) => {
    if(locale === LocaleTypeEnum.English) {
        curIdx.value = 1
    } else {
        curIdx.value = 0
    }
}, { immediate: true });    

function handleDropdown(command: number) {
    curIdx.value = command;
}
</script>
<style scoped lang="scss">

</style>
